<mat-paginator
  (page)="page.emit($event)"
  [disabled]="disabled()"
  [hidePageSize]="hidePageSize()"
  [length]="length()"
  [pageIndex]="pageIndex()"
  [pageSizeOptions]="pageSizeOptionsComputed()"
  [pageSize]="pageSizeComputed()"
  [showFirstLastButtons]="showFirstLastButtons()"
  aria-label="Select page"
></mat-paginator>
